import React, { Suspense, useState, useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { useSelector, useDispatch } from "react-redux";
import { consoleLog, handleLangUrlRedirect,
  setItemInSessionStorage,
  doFunct,setItem,
  GetQueryString, 
  getItemOfSessionStorage} from "./services/common/utils";
import { callQueryapi } from "./services/http/callapi";
import "./App.css";
import { RC4Decrypt, RC4Encrypt } from './services/common/RC4EncDec';
import Loadingcomponent from "./components/loader/loadingcomponent"; //
import HomeRoute from "./routes/home";
import HomeIndex from "./pages/home";
import EnrichmentComponent from "./pages/profile/enrichment"; //
import SpecialDealsViewAll from "./pages/special-deals/special-deals-viewall";
import SpecialDealsPay from "./pages/special-deals/specialDeals_payment";
import SpecialDealsPaymentComponent from "./pages/special-deals/specialDeals_payment";
import SelectedComponentDetails from "./pages/special-deals/selected-component-details";
import LoginVerification from "./pages/login/login-crendentials";
import OTPLoginVerification from "./pages/login/otp-login-verification";
import SpecialDealsPrepaidPayment from "./pages/special-deals/specialDeals_prepaid_payment";
import PromotionsViewAll from "./components/home/promotions/PromotionsViewAll"
import { createBootstrapComponent } from "react-bootstrap/esm/ThemeProvider";
import PaciCivilID from "./components/paci-civilid/paci-civilid";
import PaciMangeLines from "./components/paci-civilid/paci-manageLines";
import SharedOfferDetails from "./pages/common/shared-offer-details";
import ToastMessage from "./components/common/toast-message";
import ViewPackshome from "./components/home/viewPacks/RoamingHome";
import RoamingPacksBannerDesign from "./components/home/viewPacks/roamingPacksBannerDesign";

import TockenCheck from "./components/common/TockenCheck";
import {
  CHILDMSISDN, SELECTED_LANG
} from '../src/services/common/Constants';
import { useSearchParams } from 'react-router-dom';
import ProductCardDetails from './components/home/viewPacks/Product_card_details';
import RoamingInternationalRatesIndex from "./components/home/viewPacks/roaming-international-rates-index";
import ToastMessageCustom from "./components/common/toast-message-custom";

import ScrollOver from "./components/common/scroll-over";
import PageTransition from "./components/common/page-transition";
import TwoStepVerification from "./pages/call-details/AuthenticatingUser";
import MyAccountIndex from "./pages/more/My-account-index";
import { resetUserData } from "./reducer/actions";
import { resetCdrReduxData } from "./reducer/cdrSlice";
import { resetAppSliceReduxData } from "./reducer/appSlice";
import { resetAssistantData } from "./reducer/assistantSlice";
import { resetNojoomReduxData } from "./reducer/nojoomSlice";
import { resetRoamingReduxData } from "./reducer/roamingSlice";
import { resetUtilityReduxData } from "./reducer/utilitySlice";
import { PDFDoc } from "./pages/call-details/PDFDoc";

const RoamingCountryDetails = React.lazy(()=> import("./components/home/viewPacks/roamingCountryDetails"));
const ShareOffer = React.lazy(() => import("./pages/common/share-offer"));
const ApplePayComponent = React.lazy(() => import("./pages/pay/applepay")); //
const GoSellSaveCard = React.lazy(() => import("./pages/pay/gosellcheckout")); //
const OfferDetail = React.lazy(() =>
  import("./components/common/offer-detail"));
const CVMOfferDetail = React.lazy(() =>
  import("./components/home/cvm/cvm-offer-detail"));
//transfer crdit
const TransferCreditInternational = React.lazy(() =>
  import("./pages/transfer-credit/transfer-credit-international")
);

const TransferCreditReviewInternational = React.lazy(() =>
  import("./pages/transfer-credit/transfer-credit-review-international")
);

const TransferCreditReview = React.lazy(() =>
  import("./pages/transfer-credit/transfer-credit-review")
);
//esim
const EsimSelectNumber = React.lazy(() =>
  import("./pages/esim/esim-select-number")
); //
const EsimHome = React.lazy(() => import("./pages/esim/esim-home")); //
const EsimListingPages = React.lazy(() =>
  import("./pages/esim/esim-listing-pages")
); //

const EsimCivilId = React.lazy(() => import("./pages/esim/esim-civil-id")); //

const ScrollToTop = React.lazy(() =>
  import("./components/common/scroll-to-top")
); //
const AuthRoute = React.lazy(() => import("./routes/auth")); //
const LoginComponent = React.lazy(() => import("./pages/login")); //
const OTPComponent = React.lazy(() => import("./pages/login/otp")); //

const SignupEmailComponent = React.lazy(() =>
  import("./pages/login/signup-email")
); //
const SignupMobileNoComponent = React.lazy(() =>
  import("./pages/login/signup-mobileno")
); //
const LoginWithComponent = React.lazy(() =>
  import("./pages/login/social-login")
); //
const SocialLoginHomeComponent = React.lazy(() =>
  import("./pages/login/social-login-home")
); //
const OTPLoginComponent = React.lazy(() => import("./pages/login/otp-login")); //
const ChangePasswordComponent = React.lazy(() =>
  import("./pages/login/change-password")
); //
const PaymentMethod = React.lazy(() =>
  import("./pages/moremenu/paymentmethod")
);
const PaymentMethodMore = React.lazy(() =>
  import("./pages/more/payment-method")
);
const CreateNewPasswordComponent = React.lazy(() =>
  import("./pages/login/create-newpassword")
); //
const SocialLoginMMComponent = React.lazy(() =>
  import("./pages/login/socail-mm-login")
); //
const LoginHomeComponent = React.lazy(() => import("./pages/login/login-home")); //


const PayRoute = React.lazy(() => import("./routes/pay")); //


const SubPageRoute = React.lazy(() => import("./routes/subpage")); //
// const BundleComponent = React.lazy(() => import('./pages/bundle/bundle')); //
const BundleViewallComponent = React.lazy(() =>
  import("./pages/bundle/bundle-viewall")
); //
const BundleDetailComponent = React.lazy(() =>
  import("./pages/bundle/bundle-detail")
); //
const PayComponent = React.lazy(() => import("./pages/pay/pay")); //
const NojoomPayComponent = React.lazy(() => import("./pages/pay/nojoompay")); //
const ManageLinesComponent = React.lazy(() =>
  import("./pages/manage-lines/manage-lines")
); //
const EditManageLinesComponent = React.lazy(() =>
  import("./pages/manage-lines/edit-manage-lines")
); //
const RoamingComponent = React.lazy(() => import("./pages/roaming/roaming")); //
const RoamingDeals = React.lazy(() => import("./pages/roaming/roaming-deals")); //
const RoamingDealsDetailComponent = React.lazy(() =>
  import("./pages/roaming/roaming-deals-detail")
); //
const TransactionSuccessComponent = React.lazy(() =>
  import("./pages/pay/transaction-success")
); //
const TransactionDetailsComponent = React.lazy(() =>
  import("./pages/pay/transaction-details")
); //
const LineDetailsComponent = React.lazy(() =>
  import("./pages/line-details/line-details")
); //
const RechargeComponent = React.lazy(() => import("./pages/recharge/recharge")); //
const OoredooSurpriseComponent = React.lazy(() =>
  import("./pages/special-deals/ooredoo-surprise")
); //
const NotificationsComponent = React.lazy(() =>
  import("./pages/notification/notifications")
); //
const VerifyAccountComponent = React.lazy(() =>
  import("./pages/general/verify-account")
); //
const MultiRechargeComponent = React.lazy(() =>
  import("./pages/recharge/multi-recharge")
); //
// const RoamingCountriesComponent = React.lazy(() => import('./pages/roaming/roaming-countries')); //
// const RoamingInterComponent = React.lazy(() => import('./pages/roaming/roaming-inter-rates')); //
const SpecialDealsComponent = React.lazy(() =>
  import("./pages/special-deals/special-deals")
); //
const SpecialDealsDetailComponent = React.lazy(() =>
  import("./pages/special-deals/special-deals-detail")
); //
const TransactionStatus = React.lazy(() =>
  import("./pages/special-deals/transaction-status")
); //
const HelpHomeComponent = React.lazy(() => import("./pages/help/help-home")); //
const HelpStatusComponent = React.lazy(() =>
  import("./pages/help/help-status")
); //
const HelpNetworkProblemComponent = React.lazy(() =>
  import("./pages/help/help-network-problem")
); //
const HelpNetworkProblem1Component = React.lazy(() =>
  import("./pages/help/help-network-problem1")
); //
const HelpfollowupComponent = React.lazy(() =>
  import("./pages/help/help-followup")
); //
const HelpVideosComponent = React.lazy(() =>
  import("./pages/help/help-videos")
); //
const HelpsampleComponent = React.lazy(() => import("./pages/help/sample"));
const ProfileaddressComponent = React.lazy(() =>
  import("./pages/profile/myprofile-add-address")
); //
const EditmyprofileComponent = React.lazy(() =>
  import("./pages/profile/edit-myprofile")
); //

const WebFrame = React.lazy(() => import("./pages/help/web-frame")); //
const AddonsViewallComponent = React.lazy(() =>
  import("./pages/addons/addons-viewall")
); //
const RecentTransactionViewallComponents = React.lazy(() =>
  import("./pages/recent-transactions/recent-transaction-viewall")
); //
const AddonsDetailComponent = React.lazy(() =>
  import("./pages/addons/addons-detail")
); //
const RecentTransactionDetailComponent = React.lazy(() =>
  import("./pages/recent-transactions/recent-transaction-detail")
); //
const AddonsIndex = React.lazy(() => import("./pages/addons/addons-index")); //
const RecentTransacionsIndex = React.lazy(() => import("./pages/recent-transactions/recent-transactions-index")); //
const BundlesIndex = React.lazy(() => import("./pages/bundle/bundles-index")); //
const PassportCountriesComponent = React.lazy(() =>
  import("./pages/roaming/passport-countries")
); //
const PassportCountriesList = React.lazy(()=> import("./pages/roaming/passport-countries-list"));
const RoamingIndex = React.lazy(() => import("./pages/roaming/roaming-Index")); //
const RoamingInterRatesIndex = React.lazy(() =>
  import("./pages/roaming/roaming-inter-rates-index")
); //
const RoamingCountriesIndex = React.lazy(() =>
  import("./pages/roaming/roaming-countries-index")
); //
// const CountryDetailComponent = React.lazy(() => import('./pages/roaming/country-detail')); //
const SpecialOfferDealsDetail = React.lazy(() =>
  import("./pages/special-offer/special-offer-deals-detail")
); //

// const PaybillComponent = React.lazy(() => import('./pages/paybill/paybill')); //
const RequestcreditComponent = React.lazy(() =>
  import("./pages/requestcredit/requestcredit")
); //
const RequestStatusComponent = React.lazy(() =>
  import("./pages/requestcredit/request-status")
); //
const VoucherComponent = React.lazy(() => import("./pages/voucher/voucher")); //
// const MoremenuComponent = React.lazy(() => import('./pages/moremenu/moremenu')); //
const ViewbillComponent = React.lazy(() => import("./pages/viewbill/viewbill")); //
const PayBillIndex = React.lazy(() => import("./pages/paybill/paybillindex")); //
const MoreMEnuIndex = React.lazy(() =>
  import("./pages/moremenu/more-menu-index")
); //
const RoamingMultiCountries = React.lazy(() =>
  import("./pages/roaming/roaming-multi-countries")
); //
const DigitalServicesIndex = React.lazy(() =>
  import("./pages/digital-services/digital-services-index")
); //
const DigitalServicesViewallComponent = React.lazy(() =>
  import("./pages/digital-services/digital-services-viewall")
); //
const DigitalServicesDetailComponent = React.lazy(() =>
  import("./pages/digital-services/digital-services-details")
); //
const TicketSuccessComponent = React.lazy(() =>
  import("./pages/pay/ticket-sucess")
); //

const NojoomManage = React.lazy(() => import("./pages/nojoom/nojoom-manage")); //
const NojoomNumbList = React.lazy(() =>
  import("./pages/nojoom/nojoom-numbers")
); //

const ErrorComponent = React.lazy(() => import("./components/common/error")); //
const ErrorFullpgComponent = React.lazy(() =>
  import("./pages/errors/error-full-pg")
); //
const CDRTimeoutComponent = React.lazy(() =>
  import("./pages/errors/cdrtimeout")
); //

const EmailVerificationComponent = React.lazy(() =>
  import("./pages/login/email-verification")
); //
const SignupOptions = React.lazy(() => import("./pages/login/signup-options")); //
const MoreAccounts = React.lazy(() => import("./pages/moremenu/account")); //
const UpdateProfile = React.lazy(() =>
  import("./pages/moremenu/update-profile")
); //
const ChangeProfilePassword = React.lazy(() =>
  import("./pages/profile/changepassword")
); //
const DeleteAccount = React.lazy(() => import("./pages/profile/deleteaccount")); //
const DeleteAccountDetails = React.lazy(() =>
  import("./pages/profile/deletedetails")
); //
// const DeleteVerificationComponent = React.lazy(() => import('./pages/login/delete-verification')); //
const CountryDetailIndex = React.lazy(() =>
  import("./pages/roaming/country-detail-index")
); //

// const EnrichmentComponent = React.lazy(() =>
//   import("./pages/profile/enrichment")
// ); //

const OOredeoRewardsIndex = React.lazy(() =>
  import("./pages/ooredeo-rewards/ooredeorewards-index")
); //
const OOredeoRewardsViewallComponent = React.lazy(() =>
  import("./pages/ooredeo-rewards/ooredeorewards-viewall")
); //
const OOredeoRewardsDetailsIndex = React.lazy(() =>
  import("./pages/ooredeo-rewards/ooredeorewards-detail-index")
); //
const NojoomPointsHistoryInnerPage = React.lazy(() =>
  import("./components/nojoom-comp/nojoom-points-list-inner-page")
); //

const NojoomHome = React.lazy(() => import("./pages/nojoom/nojoom-home")); //
const NojoomPartner = React.lazy(() => import("./pages/nojoom/nojoom-partner")); //
const NojoomPartners = React.lazy(() =>
  import("./pages/nojoom/nojoom-partners")
); //
const NojoomPartnerDetail = React.lazy(() =>
  import("./pages/nojoom/nojoom-partner-detail")
); //

const EarnPointsHome = React.lazy(() =>
  import("./pages/earn-points/earn-points-home")
); //
const EarnPointsPartnerDetail = React.lazy(() =>
  import("./pages/earn-points/earn-points-partner-detail")
); //
const GlobalSetting = React.lazy(() =>
  import("./components/common/global-setting")
); //
const AuthModal = React.lazy(() =>
  import("./components/common/bottom-modal-auth")
); //
const TransferPointsIndex = React.lazy(() =>
  import("./pages/transfer-points/transfer-points-index")
); //
const NojoomTransferPoints = React.lazy(() =>
  import("./pages/transfer-points/nojoom-transfer-points")
); //
const NojoomPointsTransfer = React.lazy(() =>
  import("./pages/nojoom/nojoom-points-transfer")
); //

const NojoomBuyPointesPG = React.lazy(() =>
  import("./pages/nojoom/nojoom-buy-points")
); //
const HistoryDetailsComponent = React.lazy(() =>
  import("./pages/paybill/history-details")
); //

const XpressProfitHome = React.lazy(() =>
  import("./pages/xpress-profit/xpress-profit-home")
); //
const LoadBalance = React.lazy(() =>
  import("./pages/xpress-profit/load-balance")
); //
const XpressPayComponent = React.lazy(() => import("./pages/pay/xpresspay")); //
const TransferBalance = React.lazy(() =>
  import("./pages/xpress-profit/transfer-balance")
); //
const TransferReview = React.lazy(() =>
  import("./pages/xpress-profit/transfer-review")
); //
//transfer credit
const TransferCredit = React.lazy(() =>
  import("./pages/transfer-credit/transfer-credit")
); //

const InternetTransfer = React.lazy(() =>
  import("./pages/internet-transfer/internet-transfer")
); //
const AddMember = React.lazy(() =>
  import("./pages/internet-transfer/add-member")
); //
const ManageMember = React.lazy(() =>
  import("./pages/internet-transfer/manage-member")
); //
const InternetTransferReview = React.lazy(() =>
  import("./pages/internet-transfer/internet-transfer-review")
); //

const SmartPayNumbers = React.lazy(() =>
  import("./pages/smart-pay/smart-pay-numbers")
); //
const SmartPaySettings = React.lazy(() =>
  import("./pages/smart-pay/smart-pay-settings")
); //
const SmartPayCards = React.lazy(() =>
  import("./pages/smart-pay/smart-pay-cards")
); //
const SmartPayManage = React.lazy(() =>
  import("./pages/smart-pay/smart-pay-manage")
); //
const SmartPayEditNumbers = React.lazy(() =>
  import("./pages/smart-pay/smart-pay-edit-numbers")
); //
const SmartPayEditCards = React.lazy(() =>
  import("./pages/smart-pay/smart-pay-edit-cards")
); //
const RedirectAuth = React.lazy(() =>
  import("./components/auth/redirect-auth")
); //
const ManageAccount = React.lazy(() =>
  import("./pages/manage-account/manage-account")
); //

// sprint 16 components page
const Sprint16ComponentsPage = React.lazy(() => import("./pages/sprint-16/sprint-16-components-page"));

// sprint 17 components page
const Sprint17ComponentsPage = React.lazy(() => import("./pages/sprint-17/sprint-17-components-page"));

// more new pages
const MorePage = React.lazy(() => import("./pages/more/more"));
const MyAccountPage = React.lazy(() => import("./pages/more/my-account"));
const MyPaymentsPage = React.lazy(() => import("./pages/more/my-payments"));
const MyCardsPage = React.lazy(() => import("./pages/more/my-cards"));
const TermsAndConditions = React.lazy(() => import("./pages/more/terms-and-conditions"));
const PersonalInfo = React.lazy(() => import("./pages/more/personal-info"));
const PasswordManagement = React.lazy(() => import("./pages/more/password-management"));
const MoreDeleteAccount = React.lazy(() => import("./pages/more/delete-account"));
const TransactionHistory = React.lazy(() => import("./pages/more/transaction-history"));
const TransactionDetail = React.lazy(() => import("./pages/more/transaction-detail"));

// support new pages
const SupportPage = React.lazy(() => import("./pages/support/support"));
const SupportAssistant = React.lazy(() => import("./pages/support/support-assistant"));
const HelpArticalsList = React.lazy(() => import("./pages/support/help-articals-list"));
const HelpArticalsListDetail = React.lazy(() => import("./pages/support/help-articals-list-detail"));
const NeedHelpList = React.lazy(() => import("./pages/support/need-help-list"));
const NetworkAndInternetList = React.lazy(() => import("./pages/support/network-and-internet-list"));
const NetworkAndInternetListDetail = React.lazy(() => import("./pages/support/network-and-internet-list-detail"));
const Payments = React.lazy(() => import("./pages/support/payments"));
const YourBill = React.lazy(() => import("./pages/support/your-bill"));
const TrackComplaints = React.lazy(() => import("./pages/support/track-complaints"));
const OoredooPedia = React.lazy(() => import("./pages/support/ooredoo-pedia"));
const BounceEffect = React.lazy(() => import("./pages/bundle/bounce"));

// CDR (call details requirements) new pages
const VerificationOTPPage = React.lazy(() => import("./pages/call-details/verification-otp"));
const VerificationPaciPage = React.lazy(() => import("./pages/call-details/verification-paci"));
const VerificationConfirmationPage = React.lazy(() => import("./pages/call-details/verification-confirmation"));
const ChoosePage = React.lazy(() => import("./pages/call-details/choose"));
const CallDetailsPage = React.lazy(() => import("./pages/call-details/call-details"));



export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: callQueryapi,
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 30000,
      staleTime: 0,
    },
  },
});

function App() {
  const dispatch = useDispatch();
  const tokenid = useSelector((state) => state?.userdata?.value?.tokenid);
  let ChildMsisdn = useSelector((state) => state?.userdata?.value?.ChildMsisdn);
  let langrx = useSelector((state) => state?.userdata?.value?.langrx);
  //const langrx = localStorage.getItem('lang');
   try{
    if(window.location.href.indexOf("?lang=") > 0) {
      langrx =  window?.location?.href?.substring(window?.location?.href?.indexOf('=')+1);
    }
   }catch{}

 
  console.log("first tokenid:" + tokenid + ",ChildMsisdn:"+ChildMsisdn+"");
  try {
    if (tokenid != null && tokenid != undefined && tokenid != "") {
      sessionStorage.setItem("authkey", tokenid);
    }
    if (ChildMsisdn != null && ChildMsisdn != undefined && ChildMsisdn != "") {
      if(ChildMsisdn.length === 8)
        ChildMsisdn = "965"+ChildMsisdn;
      let encMobile = doFunct(ChildMsisdn, "MOBAPI");
      console.log("encMobile:" + encMobile);
      setItem(CHILDMSISDN, encMobile);
    }
    if(langrx){
      setItemInSessionStorage(SELECTED_LANG, langrx);
      if(langrx === 'ar'){
        let assest = document.getElementById("assest");
        let style = document.getElementById("main");
        assest.href = "/selfcarewebv2/assets/css/custom-ar.css?v=1";
        style.href = "/selfcarewebv2/assets/css/vendors/bootstrap.rtl.min.css";
        document.documentElement.lang = "ar"; 
        document.documentElement.dir = "rtl";
        document.title = "حسابي - My Ooredoo";
      }
    }
  } catch { }

  const [isLoaded, setisloaded] = useState(false);

  useEffect(() => {

    if(window.location.href.indexOf("?cdr") > 0){
      try{
        let _lang = getItemOfSessionStorage(SELECTED_LANG);
        try{
        dispatch(resetUserData());
        dispatch(resetCdrReduxData());
        dispatch(resetAppSliceReduxData());
        dispatch(resetAssistantData());
        dispatch(resetNojoomReduxData());
        dispatch(resetRoamingReduxData());
        dispatch(resetUtilityReduxData());
        }catch{}
        sessionStorage.clear();
        localStorage.clear();
        setItem(SELECTED_LANG, _lang);
       }catch{}

      setisloaded(true);

      return;
   }

    // try {
    const _hetokenidCheck = window.sessionStorage.getItem("authkey");
    consoleLog(
      "_hetokenidCheck:" +
      _hetokenidCheck +
      ",process.env.ENABLE_HE:" +
      process.env.REACT_APP_ENABLE_HE
    );
    if (
      (_hetokenidCheck == null ||
        _hetokenidCheck == undefined ||
        _hetokenidCheck == "") &&
      process.env.REACT_APP_ENABLE_HE == "true"
    ) {
      let pagename = window.location.hash;
      consoleLog("tokenid empty case->pagename:" + pagename + "");
      if (window.location.href.indexOf("?enc") > 0) {
        setisloaded(true);
      } else if (
        window.location.href.indexOf("transaction") > 0 &&
        window.location.href.indexOf("?tid") > 0
      ) {
        //receipt pages redirection, No need to go for enrichment, so directly checking with "?tid"
        setisloaded(true);
      } else if (window.location.href.indexOf("?nm") > 0) {
        //msisdn not found in headers, so redirecting to searched page
        try {
          var guestPN = window.location.hash.substring(window.location.hash.indexOf("#/") + 2);
          guestPN = guestPN.replace("?nm=t", "");
          guestPN = RC4Decrypt(guestPN);
          window.location.hash = '/' + guestPN;

        } catch { }
        setisloaded(true);
      } else {
        if (pagename != null && pagename != undefined && pagename != "") {
          pagename = window.location.hash.substring(
            window.location.hash.indexOf("#/") + 2
          );
          //production
          var _url ="http://auth.ooredoo.com.kw/hetoken/get?pname=!PAGENAME!&lang=en";
          //staging
           //var _url ="http://he-stgweb.ooredoo.com.kw/hetoken/get?pname=!PAGENAME!&lang=en";
           //preprod
           //var _url ="http://webpreprod-he.ooredoo.com.kw/hetoken/get?pname=!PAGENAME!&lang=en";
          try {
            pagename = RC4Encrypt(pagename)
          } catch { }
          _url = _url.toString().replace("!PAGENAME!", pagename);
          window.location.href = _url;
        } else {
          //production
          window.location.href = "http://auth.ooredoo.com.kw/hetoken/get?pname=&lang=en";
          //staging
          //window.location.href="http://he-stgweb.ooredoo.com.kw/hetoken/get?pname=&lang=en";
          //preprod
          //var _url ="http://webpreprod-he.ooredoo.com.kw/hetoken/get?pname=!PAGENAME!&lang=en";
        }
      }
    } else {
      consoleLog("tokenid case");
      setisloaded(true);
    }

    // } catch (e) { setisloaded(true);}
  }, []);

  useEffect(() => {
    handleLangUrlRedirect();
  }, []);


  return (
    <Suspense fallback={<Loadingcomponent marginTop={70}></Loadingcomponent>}>
      <div className="App">
        <QueryClientProvider client={queryClient}>
          {isLoaded ? (
            <>
              <HashRouter>

                {/* to show toasts */}
                <ToastMessage />
                <ToastMessageCustom />

                {/* scrolls to top after path change - should be placed inside router only */}
                <ScrollToTop />

                {/* to get global settings data from server */}
                <GlobalSetting />

                {/* auth modal for 2fa */}
                <AuthModal />

                {/* token validitiy check */}
                <TockenCheck />

                {/* page bounce effect */}
                 {/* <ScrollOver /> */}
                 
                {/* page transition effect */}
                 <PageTransition />

                <Routes>
                  <Route path="enrichment" element={<EnrichmentComponent />} />
                  <Route
                    path="/"
                    element={
                      <RedirectAuth>
                        <AuthRoute />
                      </RedirectAuth>
                    }
                  >
                    <Route path="" element={<LoginHomeComponent />} />
                    <Route path="login" element={<LoginVerification />} />
                    <Route path="otp" element={<OTPComponent />} />
                    <Route
                      path="signup-email"
                      element={<SignupEmailComponent />}
                    />
                    <Route path="paci-civilid" element={<PaciCivilID />}/>
                    <Route path="" element={<SubPageRoute type={20} />}>
                        <Route path="paci-managelines" element={<PaciMangeLines/>}/>
                      </Route>
                    <Route path="signup-options" element={<SignupOptions />} />
                    <Route
                      path="signup-mobileno"
                      element={<SignupMobileNoComponent />}
                    />
                    <Route
                      path="social-login"
                      element={<LoginWithComponent />}
                    />
                    <Route
                      path="social-login-home"
                      element={<SocialLoginHomeComponent />}
                    />
                    <Route
                      path="otp-login"
                      element={<OTPLoginVerification />}
                    />
                    <Route
                      path="email-verification"
                      element={<EmailVerificationComponent />}
                    />

                    <Route
                      path="change-password"
                      element={<ChangePasswordComponent />}
                    />


                    <Route
                      path="create-newpassword"
                      element={<CreateNewPasswordComponent />}
                    />
                    <Route
                      path="socail-mm-login"
                      element={<SocialLoginMMComponent />}
                    />
                    <Route path="login-home" element={<LoginHomeComponent />} />
                    <Route path="error" element={<ErrorComponent />} />
                    <Route
                      path="error-full-pg"
                      element={<ErrorFullpgComponent />}
                    />
                     <Route
                      path="cdrtimeout"
                      element={<CDRTimeoutComponent />}
                    />
                  </Route>

                  <Route path="" element={<SubPageRoute type={9} />}>
                    <Route path="recharge" element={<RechargeComponent />} />
                    <Route path="applepay" element={<ApplePayComponent />} />
                    <Route path="gosellcheckout" element={<GoSellSaveCard />} />
                    {/* <Route
                      path="managecards"
                      element={<PaymentMethod />}
                    /> */}
                    <Route
                      path="payviavoucher"
                      element={<VoucherComponent />}
                    />
                  </Route>
                  <Route path="" element={<SubPageRoute type={3} />}>
                    <Route path="promotionsviewall" element={<PromotionsViewAll/>}/> 
                    <Route path="moremenu" element={<MoreMEnuIndex />} />

                    {/* more new pages starts */}
                    <Route path="more" element={<MorePage />} />
                    <Route path='terms-and-conditions' element={<TermsAndConditions />} />
                    {/* more new pages ends */}

                    <Route path="web-frame" element={<WebFrame />} />
                    <Route
                      path="help-videos"
                      element={<HelpVideosComponent />}
                    />
                    <Route path="sample" element={<HelpsampleComponent />} />
                    <Route
                      path="myprofile-add-address"
                      element={<ProfileaddressComponent />}
                    />
                    <Route
                      path="edit-myprofile"
                      element={<EditmyprofileComponent />}
                    />
                    <Route
                      path="help-network-problem"
                      element={<HelpNetworkProblemComponent />}
                    />
                    <Route
                      path="help-network-problem/:categoryID"
                      element={<HelpNetworkProblem1Component />}
                    />
                  </Route>

                  <Route path="bounce" element={<BounceEffect />} />

                  <Route path="" element={<SubPageRoute type={8} />}>
                    <Route path="help-home" element={<HelpHomeComponent />} />

                    {/* sprint 16 components page */}
                    <Route path="sprint-16-components" element={<Sprint16ComponentsPage />} />

                    {/* sprint 17 components page */}
                    <Route path="sprint-17-components" element={<Sprint17ComponentsPage />} />

                    {/* support new routes starts */}
                   
                    <Route path="support" element={<SupportPage />} />
                    <Route path="support-assistant" element={<SupportAssistant />} />
                    <Route path="help-articles-list" element={<HelpArticalsList />} />
                    <Route path="help-articles-list-detail" element={<HelpArticalsListDetail />} />
                    <Route path="need-help-list" element={<NeedHelpList />} />
                    <Route path="network-and-internet-list" element={<NetworkAndInternetList />} />
                    <Route path="network-and-internet-list-detail" element={<NetworkAndInternetListDetail />} />
                    <Route path="ooredoo-pedia" element={<OoredooPedia />} />
                    {/* support new routes ends */}

                  </Route>
                  <Route path="" element={<SubPageRoute type={19} />}>
                    <Route
                      path="requestcredit"
                      element={<RequestcreditComponent />}
                    />
                  </Route>
                  <Route
                    path=""
                    element={
                      <SubPageRoute
                        type={tokenid !== null && tokenid !== undefined &&
                          tokenid !== "" && tokenid !== "undefined" && tokenid?.length > 0 ? 7 : 5}
                      />
                    }
                  >
                    <Route path="paybill" element={<PayBillIndex />} />
                  </Route>
                  <Route path="" element={<SubPageRoute type={6} />}>
                    <Route
                      path="help-status"
                      element={<HelpStatusComponent />}
                    />
                  </Route>

                  <Route path="" element={<PayRoute type={5} />}>
                    <Route
                      path="ticket-success"
                      element={<TicketSuccessComponent />}
                    />
                  </Route>
                  <Route path="" element={<PayRoute type={1} />}>
                  
                    <Route path="Pay" element={<PayComponent />} />
                    <Route path="NojoomPay" element={<NojoomPayComponent />} />
                    <Route path="XpessPay" element={<XpressPayComponent />} />
                  </Route>

                  <Route path="" element={<PayRoute type={5} />}>
                    <Route
                      path="transactionstatus"
                      element={<TransactionSuccessComponent />}
                    />
                    <Route
                      path="request-status"
                      element={<RequestStatusComponent />}
                    />
                    <Route
                      path="transaction-details"
                      element={<TransactionDetailsComponent />}
                    />
                    <Route
                      path="history-details"
                      element={<HistoryDetailsComponent />}
                    />
                    <Route
                      path="transaction-status"
                      element={<TransactionStatus />}
                    />
                  </Route>

                  {(
                    (tokenid !== null && tokenid !== undefined &&
                      tokenid !== "" && tokenid !== "undefined" && tokenid?.length > 0)
                    || (window.sessionStorage.getItem("authkey") !== null &&
                      window.sessionStorage.getItem("authkey") !== undefined &&
                      window.sessionStorage.getItem("authkey") !== "undefined" &&
                      window.sessionStorage.getItem("authkey") !== ""
                    )) ? (
                    <>
                      <Route path="home" element={<HomeRoute />}>
                        <Route path="" element={<HomeIndex />} />
                        <Route path="index" element={<HomeIndex />} />
                      </Route>
                      <Route>
                        <Route path="test" element={<PDFDoc/>}/>
                      </Route>
                      <Route
                        path="emailVerification"
                        element={<EmailVerificationComponent />}
                      />
                      <Route
                        path="nojoom"
                        element={<HomeRoute isNojoomHome={true} />}
                      >
                        <Route path="" element={<NojoomHome />} />
                      </Route>
                      <Route path="" element={<SubPageRoute type={12} />}>
                        <Route
                          path="ooredeorewards-home"
                          element={<OOredeoRewardsIndex />}
                        />
                      </Route>
                      <Route path="" element={<SubPageRoute type={15} />}>
                        <Route
                          path="transferPoints-home"
                          element={<TransferPointsIndex />}
                        />
                        <Route
                          path="nojoomtransferfriends"
                          element={<NojoomPointsTransfer />}
                        />
                        <Route
                          path="nojoomdonate"
                          element={<NojoomPointsTransfer />}
                        />
                        <Route
                          path="transfertopartner"
                          element={<NojoomTransferPoints />}
                        />
                      </Route>

                      <Route path="" element={<SubPageRoute type={14} />}>
                        <Route
                          path="nojoom-manage"
                          element={<NojoomManage />}
                        />
                        <Route
                          path="line-details"
                          element={<LineDetailsComponent />}
                        />
                      </Route>
                      <Route path="" element={<SubPageRoute type={13} />}>
                        <Route
                          path="ooredeorewards-details/:categoryID"
                          element={<OOredeoRewardsDetailsIndex />}
                        />
                        <Route
                          path="ooredeorewards-viewall/:categoryID"
                          element={<OOredeoRewardsViewallComponent />}
                        />
                      </Route>

                      <Route path="" element={<SubPageRoute type={1} />}>
                        <Route path="bundles" element={<BundlesIndex />} />
                        <Route path="addonshome" element={<AddonsIndex />} />
                        <Route
                          path="addons-viewall/:categoryID"
                          element={<AddonsViewallComponent />}
                        />
                        <Route
                          path="bundles-viewall/:categoryID"
                          element={<BundleViewallComponent />}
                        />
                        <Route
                          path="bundles-detail/:categoryID"
                          element={<BundleDetailComponent />}
                        />
                        <Route
                          path="addons-detail/:categoryID"
                          element={<AddonsDetailComponent />}
                        />
                         <Route
                          path="recent-Transaction-detail"
                          element={<RecentTransactionDetailComponent />}
                        />
                         <Route path="recent-Transaction-Home" element={<RecentTransacionsIndex />} />
                         <Route
                          path="recent-Transaction-Viewall/:categoryID"
                          element={<RecentTransactionViewallComponents />}
                        />
                        <Route
                          path="digitalservices"
                          element={<DigitalServicesIndex />}
                        />
                        <Route
                          path="digitalservices-viewall/:categoryID"
                          element={<DigitalServicesViewallComponent />}
                        />
                        <Route
                          path="digitalservices-detail/:categoryID"
                          element={<DigitalServicesDetailComponent />}
                        />

                        <Route
                          path="manage-lines"
                          element={<ManageLinesComponent />}
                        />

                        <Route path="roaming" element={<RoamingComponent />} />
                        <Route
                          path="roaming-deals"
                          element={<RoamingDeals />}
                        />
                        <Route
                          path="roaming-deals-detail/:offerId"
                          element={<RoamingDealsDetailComponent />}
                        />
                        <Route
                          path="roaming_product_details/:offerId"
                          element={<ProductCardDetails/>}
                        />
                        <Route
                          path="special-offer-deals-detail/:offerId"
                          element={<SpecialOfferDealsDetail />}
                        />
                        {/* <Route
                          path="line-details"
                          element={<LineDetailsComponent />}
                        /> */}
                        <Route
                          path="recharge"
                          element={<RechargeComponent />}
                        />
                        <Route
                          path="applepay"
                          element={<ApplePayComponent />}
                        />

                        <Route path="gosellcheckout" element={<GoSellSaveCard />} />
                        <Route
                          path="managecards"
                          element={<PaymentMethod />}
                        />
                        {/* more payment method route */}
                        <Route
                          path="payment-method"
                          element={<PaymentMethodMore />}
                        />
                        {/* more payment method route */}
                        <Route
                          path="roaming-rates"
                          element={<RoamingIndex />}
                        />
                        <Route
                          path="deleteaccount"
                          element={<DeleteAccount />}
                        />
                        <Route
                          path="deletedetails"
                          element={<DeleteAccountDetails />}
                        />

                        <Route
                          path="mycountryhome"
                          element={<RoamingCountriesIndex />}
                        />
                        
                        {/* <Route
                          path = "country_details_packs/:sno"
                          element={<RoamingCountryDetails/>}
                        /> */}
                        <Route
                          path="passportmulticountry"
                          element={<RoamingMultiCountries />}
                        />
                        <Route
                          path="countries-detail/:categoryID"
                          element={<CountryDetailIndex />}
                        />
                        <Route
                          path="passport-countries"
                          element={<PassportCountriesComponent />}
                        />
                         <Route
                          path="passport-countries-list"
                          element={<PassportCountriesList />}
                        />
                        <Route
                          path="help-network-problem"
                          element={<HelpNetworkProblemComponent />}
                        />
                        <Route
                          path="help-network-problem/:categoryID"
                          element={<HelpNetworkProblem1Component />}
                        />
                        <Route
                          path="help-followup"
                          element={<HelpfollowupComponent />}
                        />
                        <Route
                          path="special-deals"
                          element={<SpecialDealsComponent />}
                        />

                        <Route
                          path="special-deals-viewall"
                          element={<SpecialDealsViewAll />}
                        />


                        <Route
                          path="selected-special-deal-detail/:offerCode"
                          element={<SelectedComponentDetails />}
                        />
                        <Route
                          path="special-deals-detail/:offerCode"
                          element={<SpecialDealsDetailComponent />}
                        />
                        <Route
                          path="cvm-offer-detail/:offerCode"
                          element={<CVMOfferDetail />}
                        />
                        <Route
                          path="offer-detail/:offerid"
                          element={<OfferDetail />}
                        />
                        <Route path="shared-offer-details/:offerid" element={<SharedOfferDetails />}/>

                        <Route path="moremenu" element={<MoreMEnuIndex />} />

                         {/* more new pages starts */}
                        <Route path="more" element={<MorePage />} />
                        <Route path='my-account' element={<MyAccountIndex />} />
                        <Route path='my-payments' element={<MyPaymentsPage />} />
                        <Route path='my-cards' element={<MyCardsPage />} />
                        <Route path='terms-and-conditions' element={<TermsAndConditions />} />
                        <Route path='personal-info' element={<PersonalInfo />} />
                        <Route path='password-management' element={<PasswordManagement />} />
                        <Route path='delete-account' element={<MoreDeleteAccount />} />
                        <Route path='transaction-history' element={<TransactionHistory />} />
                        <Route path='transaction-detail' element={<TransactionDetail />} />
                        {/* more new pages ends */}

                        {/* call details pages starts */}
                        <Route path="verification-otp" element={<VerificationOTPPage />} />
                        <Route path="verification" element={<TwoStepVerification/>}/>
                        <Route path="verification-paci" element={<VerificationPaciPage />} />
                        <Route path="verification-confirmation" element={<VerificationConfirmationPage />} />
                        <Route path="choose" element={<ChoosePage />} />
                        <Route path="call-details" element={<CallDetailsPage />} />
                        {/* call details pages ends */}

                        <Route
                          path="updateprofile"
                          element={<UpdateProfile />}
                        />
                        <Route
                          path="changepassword"
                          element={<ChangeProfilePassword />}
                        />

                      </Route>
                      <Route path="" element={<SubPageRoute type={6} />}>
                        <Route
                          path="nojoom-buypoints"
                          element={<NojoomBuyPointesPG />}
                        />
                        <Route
                          path="nojoom-partners"
                          element={<NojoomPartners />}
                        />
                        <Route
                          path="nojoom-partner/:id"
                          element={<NojoomPartner />}
                        />
                        <Route
                          path="nojoom-partner-detail/:id"
                          element={<NojoomPartnerDetail />}
                        />

                        <Route
                          path="earn-points"
                          element={<EarnPointsHome />}
                        />
                        <Route
                          path="earn-points-partner-detail/:id"
                          element={<EarnPointsPartnerDetail />}
                        />

                        <Route
                          path="xpress-profit"
                          element={<XpressProfitHome />}
                        />
                        <Route path="load-balance" element={<LoadBalance />} />
                        <Route
                          path="transfer-balance"
                          element={<TransferBalance />}
                        />
                        <Route
                          path="transfer-review"
                          element={<TransferReview />}
                        />

                        <Route
                          path="internet-transfer"
                          element={<InternetTransfer />}
                        />
                        <Route path="add-member" element={<AddMember />} />
                        <Route
                          path="manage-member"
                          element={<ManageMember />}
                        />
                        <Route
                          path="internet-transfer-review"
                          element={<InternetTransferReview />}
                        />

                        <Route
                          path="smart-pay-numbers"
                          element={<SmartPayNumbers />}
                        />
                        <Route
                          path="smart-pay-settings"
                          element={<SmartPaySettings />}
                        />
                        <Route
                          path="smart-pay-cards"
                          element={<SmartPayCards />}
                        />
                        <Route
                          path="smart-pay-manage"
                          element={<SmartPayManage />}
                        />
                        <Route
                          path="smart-pay-edit-numbers"
                          element={<SmartPayEditNumbers />}
                        />
                        <Route
                          path="smart-pay-edit-cards"
                          element={<SmartPayEditCards />}
                        />

                        <Route path="share-offer" element={<ShareOffer />}/>

                        <Route path="manage-account" element={<ManageAccount />}/>
                      </Route>
                      <Route path="" element={<SubPageRoute type={10} />}>
                        <Route path="moreaccounts" element={<MoreAccounts />} />
                      </Route>
                      <Route path="" element={<SubPageRoute type={11} />}>
                        <Route
                          path="countries-detail/:categoryID"
                          element={<CountryDetailIndex />}
                        />
                      </Route>
                      <Route path="" element={<SubPageRoute type={18} />}>
                        <Route
                          path="transfer-credit"
                          element={<TransferCredit />}
                        />
                        <Route
                          path="transfer-credit-review"
                          element={<TransferCreditReview />}
                        />
                        <Route
                          path="transfer-credit-review-international"
                          element={<TransferCreditReviewInternational />}
                        />
                        <Route
                          path="transfer-credit-international"
                          element={<TransferCreditInternational />}
                        />
                      </Route>
                      <Route path="" element={<SubPageRoute type={17} />}>
                        <Route path="esim" element={<EsimHome />} />
                        <Route
                          path="esim-listing"
                          element={<EsimListingPages />}
                        />
                        <Route path="esim-civilId" element={<EsimCivilId />} />
                        <Route
                          path="esim-select-number"
                          element={<EsimSelectNumber />}
                        />
                      </Route>

                      <Route path="" element={<SubPageRoute type={2} />}>
                        <Route
                          path="edit-manage-lines"
                          element={<EditManageLinesComponent />}
                        />
                        <Route
                          path="notifications"
                          element={<NotificationsComponent />}
                        />
                        {/* <Route
                          path="roaming-inter-rates/:Id"
                          element={<RoamingInterRatesIndex />}
                        /> */}
                      </Route>
                      <Route path="" element={<SubPageRoute type={16} />}>
                        <Route
                          path="nojoom-numbers"
                          element={<NojoomNumbList />}
                        />
                        <Route
                          path="nojoom-points-history-page"
                          element={<NojoomPointsHistoryInnerPage />}
                        />
                        <Route
                          path="country_details_packs/:sno"
                          element={<RoamingCountryDetails/>}
                        />
                        <Route
                          path="roaming-inter-rates/:Id"
                          element={<RoamingInterRatesIndex />}
                        />
                        <Route
                          path="roaming-international-rates/:Id"
                          element={<RoamingInternationalRatesIndex />}
                        />
                      </Route>
                      <Route path="" element={<SubPageRoute type={4} />}>
                        <Route
                          path="verify-account"
                          element={<VerifyAccountComponent />}
                        />
                      </Route>                      
                      <Route path="" element={<SubPageRoute type={19} />}>
                        <Route
                          path="requestcredit"
                          element={<RequestcreditComponent />}
                        />
                      </Route>
                      <Route path="" element={<PayRoute type={1} />}>
                        <Route
                          path="special-deals-pay"
                          element={<SpecialDealsPaymentComponent />}
                        />
                        <Route path="Pay" element={<PayComponent />} />
                        <Route
                          path="NojoomPay"
                          element={<NojoomPayComponent />}
                        />

                        <Route
                          path="payviavoucher"
                          element={<VoucherComponent />}
                        />
                        <Route
                          path="special-deals-payment"
                          element={<SpecialDealsPay />}
                        />
                        <Route
                          path="special-deals-prepaid-payment"
                          element={<SpecialDealsPrepaidPayment />}
                        />
                      </Route>
                      <Route path="" element={<PayRoute type={4} />}>
                        <Route
                          path="viewbill"
                          element={<ViewbillComponent />}
                        />
                      </Route>
                      <Route path="" element={<PayRoute type={3} />}>
                        <Route
                          path="ooredoo-surprise"
                          element={<OoredooSurpriseComponent />}
                        />
                      </Route>
                      <Route path="" element={<PayRoute type={5} />}>
                        <Route
                          path="transactionstatus"
                          element={<TransactionSuccessComponent />}
                        />

                        <Route
                          path="transaction-details"
                          element={<TransactionDetailsComponent />}
                        />
                        <Route
                          path="history-details"
                          element={<HistoryDetailsComponent />}
                        />
                        <Route
                          path="add-numbers"
                          element={<MultiRechargeComponent />}
                        />
                        <Route
                          path="transaction-status"
                          element={<TransactionStatus />}
                        />
                        <Route
                          path="request-status"
                          element={<RequestStatusComponent />}
                        />
                      </Route>
                      <Route
                        path="createNewpassword"
                        element={<ChangePasswordComponent />}
                    />
                      <Route path="" element={<SubPageRoute type={21} />}> 
                        <Route 
                          path = "roaminghome"
                          element={<ViewPackshome/>}
                        />
                       </Route>

                       <Route path="" element={<SubPageRoute type={21} />}> 
                        <Route 
                          path = "roaminghomedesign"
                          element={<RoamingPacksBannerDesign/>}
                        />
                       </Route>

                       <Route path="" element={<SubPageRoute type={8} />}>
                        {/* support new routes starts */}
                        <Route path="payments" element={<Payments />} />
                        <Route path="your-bill" element={<YourBill />} />
                        <Route path="track-complaints" element={<TrackComplaints />} />
                        {/* support new routes ends */}

                      </Route>
                    </>
                  ) : (
                    <Route path="*" element={  <LoginHomeComponent />} />
                  )}
                </Routes>
              </HashRouter>
            </>
          ) : (
            <Loadingcomponent marginTop={70}></Loadingcomponent>
          )}
        </QueryClientProvider>
      </div>
    </Suspense>
  );
}

export default App;
